<script>	// custom svelte components
	import MiniLineChart  from '../components/MiniLineChart.svelte';
	import { scale } from 'svelte/transition';
	import { onMount } from 'svelte';

    import State, { Drivers } from '../stores/State.js';
    import lapData from '../data/raceLapData.js';
    import races from '../data/racesData.js';

    let w;
    let hoverDriver = "";
    let driverList = Object.keys($Drivers);
    
    $: if (hoverDriver === $State.selDriver || hoverDriver === 'None') hoverDriver = "";

	onMount(() => {
        window.scrollTo(0, 0);
	});
   
</script>
  

<div class="container">
    
        <h2 bind:clientWidth={w} in:scale={{ duration:500}} >
            Lightning Grid
        </h2>
 
        <h3>Each race highlighting &nbsp;
                <strong
                    in:scale={{ duration:500}}
                    class="driverDropdown"
                >
                    {$State.selDriver} 
                </strong>
                <select class="selectNative" bind:value={$State.selDriver}>
                    {#each driverList as dr}
                        <option value={dr}>
                            {dr}
                        </option>
                    {/each}
                </select>

                {#if hoverDriver !== "" && hoverDriver !=="$State.selDriver"} &nbsp;&nbsp;vs&nbsp;&nbsp;
                <strong style="color:#bbb">
                    {hoverDriver}
                </strong>
                <select class="selectNative" bind:value={hoverDriver}>
                    {#each ['None', ...driverList] as dr}
                        <option value={dr}>
                            {dr}
                        </option>
                    {/each}
                </select>
                {/if}

        </h3>

        <a role="button" href="/" class="btn btnLightning">&nbsp;</a>
        <div class="btnText">Back</div>

        <br>
        <br>
        
        <div class="gridContainer">
            {#each races as race}
                <MiniLineChart driverLaps={lapData[race.race]} {race} bind:hoverDriver={hoverDriver}/>
            {/each}
        </div>
        <div class="spacer" style="height:100px"></div>   
        
        <div class="pageNav">
            <div class="links">
                <a href="/">Back</a> &nbsp;&nbsp;&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;&nbsp;<a href="/about">About Me</a>&nbsp;&nbsp;&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;&nbsp;<a href="/credits">Credits</a>
                <div style="display:inline; float:right; "><a href="mailto:joeycherdarchuk@gmail.com" style="text-transform:lowercase; font-family:'Titillium Web', sans-serif">joeycherdarchuk@gmail.com</a></div>
            </div>
        </div>
            
</div>




<style>

    .selectNative {
        width: 20px;
        height: 20px;
        border-radius: 99px;
        border: 1px solid #343135;
        background-color: #00000000;
        background-image: url("data:image/svg+xml;utf8,<svg width='11' height='7' viewBox='0 0 11 7' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 1L5.5 5.5L10 1' stroke='white' stroke-width='2'/></svg>");
        background-repeat: no-repeat;
        background-position: center;
        position: relative;
        -webkit-appearance: none;
        box-shadow: -2px -2px 8px 0px #FFFFFF80, 2px 3px 8px 1px #000000;
        margin: 0 0 0 5px;
        line-height: 0px;

    }

    .gridContainer {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        column-gap: 35px;
        row-gap: 35px;
    }

    .selectNative:hover {
        box-shadow: -2px -2px 8px 0px #FFFFFF80, 2px 3px 8px 1px #000000, 0 0 0 2px #FF285D;
    }

    .selectNative:focus {
        -webkit-appearance: none;
        outline: 1px solid #FF285D;
    }

	h2 {
	  font-weight: bold;
      max-width: 900px;
      margin-top: 8px;
	}

   
    .btn {
        display: inline-block;
        margin-top: 15px;
        margin-bottom: 0;
        width: 30px;
        height: 30px;
        border-radius: 99px;
        border: 1px solid #343135;
        background-color: #00000000;
        box-shadow: -2px -2px 8px 0px #FFFFFF80, 2px 3px 8px 1px #000000;
        background-repeat: no-repeat;
        background-position: center;
        position: relative;
        -webkit-appearance: none;
    }

    .btn:hover {
        box-shadow: -2px -2px 8px 0px #FFFFFF80, 2px 3px 8px 1px #000000, 0 0 0 2px #FF285D;
    }

    .btn:active, .selected .btn {
        box-shadow: inset 1px 2px 2px rgba(0, 0, 0, 0.8), inset -1px -1px 2px rgba(255, 255, 255, 0.5);
        background-color: #00000000;
    }

    .btnLightning {
        background-image: url('data:image/svg+xml;utf8,<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.5 1C9.5 1 4.0625 4 4.0625 4.5C4.0625 5 4.125 8.5 4.0625 9C4 9.5 1 13 1 13" stroke="%23999999" stroke-linecap="round"/><path d="M9.49957 1C9.49957 1 11.8746 4 11.9371 4.5C11.9996 5 11.9371 9 11.9371 9L10.9996 13" stroke="%23999999" stroke-linecap="round"/><path d="M9.5 1C9.5 1 6.625 4 6.3125 4.5C6 5 7 8.5 7 9C7 9.5 5 13 5 13" stroke="%23999999" stroke-linecap="round"/><path d="M9.5 1C9.5 1 9 4.5 9 5C9 5.5 11.9375 9 11.9375 9L15 13" stroke="%23999999" stroke-linecap="round"/></svg>');
    } 

    .btnText {
        display: inline-block;
        height: 30px;
        line-height: 30px;
        vertical-align: bottom;
        margin-left: 10px;
        font-size: 14px;
        text-transform: uppercase;
        color: #F0B8C9;
        font-family: 'Poppins', 'Century Gothic', sans-serif;
    }


    .container {
	  max-width: 1200px;
	  margin: 0 auto;
      padding: 0 20px;
    }

    .pageNav {
        position: fixed;
        bottom: 0;
        left: 0;
        font-size: 12px;
        font-family: 'Poppins', 'Century Gothic', sans-serif;
        background-color: #1B1F22;
        width: 100%;
        padding: 15px 0;
        /* border-top: solid 1px #222; */
    }

    .pageNav a {
        color: #9CBCE0;
        text-transform: uppercase;
        border: none;
    }
    
    .pageNav a:hover {
        text-decoration: none;
        border-bottom: 1px dashed #9CBCE0;
    }

    .links {
	  max-width: 1200px;
	  margin: 0 auto;
      padding: 0 40px;
    }


    @media screen and (max-width: 1280px) {
        .container, .links {
	        max-width: 900px;
        }
        .gridContainer {
            column-gap: 20px;
        }
    }


</style>